import { render } from "./BroadcastGivingSummaryCard.vue?vue&type=template&id=1e4e3b48"
import script from "./BroadcastGivingSummaryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastGivingSummaryCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/Broadcast/BroadcastGivingSummaryCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e4e3b48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e4e3b48', __exports__)) {
    api.reload('1e4e3b48', __exports__)
  }
  
  module.hot.accept("./BroadcastGivingSummaryCard.vue?vue&type=template&id=1e4e3b48", () => {
    api.rerender('1e4e3b48', render)
  })

}


export default __exports__